// extracted by mini-css-extract-plugin
module.exports = {"loadingPadding":"src-common-main-navbar-main-navbar__loadingPadding--3s37D"};